/* tslint:disable */
/* eslint-disable */
/**
 * Streem API
 * The Streem API gives you access to information captured during Streem calls.  You can retrieve artifacts such as recordings, streemshots (including captured model/serial numbers), and much more.
 *
 * The version of the OpenAPI document: 0.1.0
 * Contact: support@streem.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { exists } from '../runtime';
import { StreemApiWebhookSigningKeyFromJSON, StreemApiWebhookSigningKeyToJSON, } from './';
export function StreemApiListSigningKeysResponseFromJSON(json) {
    return StreemApiListSigningKeysResponseFromJSONTyped(json, false);
}
export function StreemApiListSigningKeysResponseFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'signingKeys': !exists(json, 'signing_keys') ? undefined : (json['signing_keys'].map(StreemApiWebhookSigningKeyFromJSON)),
        'nextPageToken': !exists(json, 'next_page_token') ? undefined : json['next_page_token'],
        'totalSize': !exists(json, 'total_size') ? undefined : json['total_size'],
    };
}
export function StreemApiListSigningKeysResponseToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'signing_keys': value.signingKeys === undefined ? undefined : (value.signingKeys.map(StreemApiWebhookSigningKeyToJSON)),
        'next_page_token': value.nextPageToken,
        'total_size': value.totalSize,
    };
}
//# sourceMappingURL=StreemApiListSigningKeysResponse.js.map